module.exports = __webpack_public_path__ + "static/media/profile.45c9eb01.jpg";